import React from "react";
import { motion } from "framer-motion";
import Container from "./Container";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";
import "../css/Short.css";

export default function Short() {
  return (
    <Container>
      <div style={{ padding: "120px 0", overflow: "hidden" }}>
        <div
          className="short-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-around",
            padding: "0 20px",
            gap: "60px",
          }}
        >
          <motion.div
            className="short-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "600px",
              flex: "1 1 300px",
            }}
          >
            <h3
              style={{
                margin: "0 0 30px 0",
                fontSize: "clamp(24px, 5vw, 36px)",
                lineHeight: "1.4",
                fontWeight: "300",
              }}
            >
              “I craft intuitive websites where{" "}
              <span style={{ fontWeight: "600", color: "rgb(69, 92, 233)" }}>
                design meets code
              </span>{" "}
              building seamless interfaces that engage users and bring ideas to
              life.”
            </h3>
            <p
              style={{
                margin: 0,
                fontSize: "18px",
                lineHeight: "1.8",
                fontWeight: "400",
                opacity: 0.7,
                maxWidth: "500px",
              }}
            >
              Fusing design, code, and interaction to engineer purposeful
              digital experiences where innovation thrives and every pixel
              delivers impact.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8, rotate: 10 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2, type: "spring" }}
          >
            <Link to="about">
              <motion.button
                className="about-me-btn"
                whileHover={{ scale: 1.05, rotate: -5 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  width: "200px",
                  height: "200px",
                  border: "none",
                  borderRadius: "50%",
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "20px",
                  cursor: "pointer",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                }}
              ></motion.button>
            </Link>
          </motion.div>
        </div>

        <motion.div
          initial={{ scaleX: 0, opacity: 0 }}
          whileInView={{ scaleX: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.5, ease: "circOut" }}
          style={{ marginTop: "100px" }}
        >
          <Divider
            variant="middle"
            sx={{ borderColor: "white", opacity: 0.5 }}
          />
        </motion.div>
      </div>
    </Container>
  );
}
